module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAWElEQVR42mMY4cD7Py5IqoYHpGl44K3gXY/VFmzWQ5TjcBhu08GwgTgbEMoxAUmmIzTgMp2ADcime8vj1QDjIZR738erAaYNoZyomIaIgJSTnDTI0zDSAQBIaMYu9ZDRPQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/review-24.png
// module id = omNI
// module chunks = 1